export default __webpack_public_path__ + "static/portrait6-e4fd00e04e60df6e853b99c2a4dd61e6.jpg";